export default "__VITE_ASSET__ec8d610f__"